import * as React from "react"

import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

const IconTwitterShare = ({
  title = "Twitter share",
  viewBoxWidth = 20,
  viewBoxHeight = 16,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M20 1.9c-.7.3-1.5.5-2.4.6A4 4 0 0019.4.3c-.7.5-1.6.8-2.6 1a4.1 4.1 0 00-7 2.7v1C6.5 4.8 3.5 3.2 1.5.7a4 4 0 001.3 5.4C2 6.1 1.4 6 .8 5.6a4 4 0 003.3 4 4.2 4.2 0 01-1.9.1c.6 1.6 2 2.8 3.9 2.8A8.3 8.3 0 010 14.2C1.8 15.3 4 16 6.3 16A11.5 11.5 0 0018 4c.8-.6 1.5-1.3 2-2.1z"
      fill="#1EA1F2"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconTwitterShare
